import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import {
  COMPLEX_SELECT,
  ComplexSelectCompanyApiResponse,
  ComplexSelectValueApiResponse,
} from '@/components/form-elements/ComplexSelect/types';

export class ComplexSelectHttpService extends HttpService {
  loadCompanies(
    type: COMPLEX_SELECT,
  ): HttpClientResponse<ComplexSelectCompanyApiResponse> {
    return this.httpClient.get(`choices/${type}/companies`);
  }

  loadValues(
    query: string,
    companyIds: number[],
    type: COMPLEX_SELECT,
  ): HttpClientResponse<ComplexSelectValueApiResponse> {
    return this.httpClient.get(`choices/${type}`, {
      params: {
        q: query,
        'filter[gesellschaft]': companyIds.join(','),
      },
    });
  }
}
